export const preventTransformX = (style) => {
    if (style?.transform) {
        const axisLockX = style.transform.slice(0, style.transform.indexOf(",")) + ", 0px)";
        return { ...style, transform: axisLockX };
    }
    return style;
};
